import type { PublicDefaultPaymentProviderApiResponse } from '@gohighlevel/ghl-proposals-common'
import config from '@/config'
import { requests } from '.'

export const PaymentPublicService = {
  fetchPublicDefaultPaymentProvider: (params: { altId: string; liveMode: boolean }) =>
    requests(config.PAYMENTS_SERVICE_URL).get<PublicDefaultPaymentProviderApiResponse>('/integrations/provider/default/public', {
      params: {
        altId: params.altId,
        altType: 'location',
        liveMode: params.liveMode,
        with: 'paymentSetting',
        saasVerifyProviderLocation: false,
      },
    }),
}
